import logo from './logo.svg';
import './App.css';
import Clock from './component/Clock';


function App() {
  return (
    <div className="App">
   
  <Clock></Clock>
 
    </div>
  );
}

export default App;
